import { Effect, Layer, type Context } from "effect";
import { editorModelDependencyFailure } from "./model.ts";
import { EditorWidgetIo } from "./widget-service.ts";
import { EditorPlatform } from "./platform-service.ts";
type Port = Context.Service.Shape<typeof EditorWidgetIo>;
export const EditorWidgetIoLive = Layer.effect(EditorWidgetIo, Effect.gen(function* () {
  const platform = yield* EditorPlatform;
  const load = Effect.tryPromise({ try: () => import("./widget-monaco-live.ts"), catch: editorModelDependencyFailure });
  return EditorWidgetIo.of({
    acquire: Effect.fn("Frontend.EditorWidgetIo.lazyAcquire")(function* (...args: Parameters<Port["acquire"]>) { yield* platform.ready.pipe(Effect.mapError(editorModelDependencyFailure)); return yield* (yield* load).editorWidgetIo.acquire(...args); }),
    bind: Effect.fn("Frontend.EditorWidgetIo.lazyBind")(function* (...args: Parameters<Port["bind"]>) { return yield* (yield* load).editorWidgetIo.bind(...args); })
  });
}));
